module.exports = __webpack_public_path__ + "static/vista-3-d690276cacb2988a499d16077cee1347.png";